/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React, { useState } from 'react';
import {
    object, string, func, shape, number,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button/Button';
import Grid from '@material-ui/core/Grid';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CustomsCardWrapper from '../CustomsCardWrapper/CustomsCardWrapper';

const styles = (theme) => ({
    title: {
        fontSize: '1.5rem',
        textAlign: 'center',
        padding: '1.5rem 0px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.125rem',
        },
    },
    iconsRight: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        [theme.breakpoints.down(855)]: {
            position: 'absolute',
            bottom: 0,
            right: '5%',
            top: 0,

        },

    },
    iconsLeft: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down(855)]: {
            position: 'absolute',
            bottom: 0,
            left: '5%',
            top: 0,

        },
    },
    customs: {
        display: 'flex',
        justifyContent: 'center',
        margin: '1.875rem 0px',
        [theme.breakpoints.down(855)]: {
            flexBasis: '85%',
            maxWidth: '85%',
            margin: '0 auto',
        },
    },

    selectButtonContainer: {
        textAlign: 'center',
        margin: '1.875rem 0',
    },
    selectButton: {
        background: theme.palette.common?.black,
        color: theme.palette.common?.white,
        '&:hover': {
            background: theme.palette.common?.black,
        },
    },
});
const CUSTOMS_VIEWS = {
    SELECT_IMAGE: 'photo',
    SELECT_MESSAGE: 'text',
    SELECT_IMAGE_AND_MESSAGE: 'both',
};
const SelectCelebrationsCustomsCard = ({
    customsCard, classes, setCustomsCardType, customData,
}) => {
    const [customsType, setCustomsType] = useState(CUSTOMS_VIEWS.SELECT_IMAGE);
    return (
        <>
            <Grid item sm={2} className={classes.iconsLeft}>
                {customsType === CUSTOMS_VIEWS.SELECT_MESSAGE ? <ArrowBackIosIcon onClick={() => setCustomsType(CUSTOMS_VIEWS.SELECT_IMAGE)} /> : null}
                {customsType === CUSTOMS_VIEWS.SELECT_IMAGE_AND_MESSAGE ? <ArrowBackIosIcon onClick={() => setCustomsType(CUSTOMS_VIEWS.SELECT_MESSAGE)} /> : null}
            </Grid>
            <Grid item sm={8} xs={12} className={classes.customs}>
                <CustomsCardWrapper customsCard={customsCard} customData={customData}>
                    {customsType === CUSTOMS_VIEWS.SELECT_IMAGE
                        ? <Typography variant="h3" className={classes.title}>Your Photo Here</Typography>
                        : null}
                    {customsType === CUSTOMS_VIEWS.SELECT_MESSAGE
                        ? <Typography variant="h3" className={classes.title}>Your Message Here</Typography>
                        : null}
                    {customsType === CUSTOMS_VIEWS.SELECT_IMAGE_AND_MESSAGE
                        ? (
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography variant="h3" className={classes.title}>Your Photo Here</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="h3" className={classes.title}>Your Message Here</Typography>
                                </Grid>
                            </Grid>
                        )
                        : null}
                </CustomsCardWrapper>
            </Grid>
            <Grid item sm={2} className={classes.iconsRight}>
                {customsType === CUSTOMS_VIEWS.SELECT_IMAGE ? <ArrowForwardIosIcon data-testid="arrowforward-select-image" onClick={() => setCustomsType(CUSTOMS_VIEWS.SELECT_MESSAGE)} /> : null}
                {customsType === CUSTOMS_VIEWS.SELECT_MESSAGE ? <ArrowForwardIosIcon data-testid="arrowforward-select-msg" onClick={() => setCustomsType(CUSTOMS_VIEWS.SELECT_IMAGE_AND_MESSAGE)} /> : null}
            </Grid>
            <Grid item xs={12} className={classes.selectButtonContainer}>
                <Button type="submit" className={classes.selectButton} onClick={() => setCustomsCardType(customsType)}>SELECT THIS OPTION</Button>
            </Grid>
        </>
    );
};

SelectCelebrationsCustomsCard.propTypes = {
    classes: object.isRequired,
    customsCard: string.isRequired,
    setCustomsCardType: func.isRequired,
    customData: shape({
        content_area_width: number,
        content_area_height: number,
        message_image_settings: shape({
            image_width: number,
        }),
        message_settings: shape({
            heading_font_size: string,
        }),
    }).isRequired,
};

export default withStyles(styles)(SelectCelebrationsCustomsCard);
